/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const reserveChangeSlice = createSlice({
  name: 'reserveChange',
  initialState: {
    lgCd: '',
    receptionId: '',
    citizenId: '',
    timearea: '',
    business: {},
    recItem: [],
    rsvDate: '',
    rsvDateWithTime: '',
    rsvDayOfWeek: '',
    rsvFlameId: '',
    userName: '',
    address: '',
    birthday: '',
    telNum: '',
    mailAddress: '',
    url: '',
    rsvSetId: '',
    sendType: 1,
    place: { id: '', name: '', address: '', subAddress: '', tel: '' },
    useHome: true,
    rsvFlag: 0,
    // 予約変更モード関連
    businessChangeMode: 1, // 1=①(デフォルト), 2=②, 3=③
    businessChanged: false, // ChangeBusiness で用件が変更されたか
    dateChanged: false, // ChangeDate で元の予約日以外の日付を選択したか
    numOfAttendees: 0, // 同席者数（ChangeOrCancel で保存）
    originalRecItem: [], // 変更前の用件（比較用・上書きしない）
    answerList: [], // ChangeForm で入力したフォーム回答
    fromChangeForm: false, // ChangeForm を経由したか
    note:"",
    baseName:"",
    summaryPanelOpen: true, // ChangeSelectionSummary: PCパネルの開閉状態（画面遷移をまたいで保持する）
    summaryExpanded: false, // ChangeSelectionSummary: スマホバーの展開/折りたたみ状態（画面遷移をまたいで保持する）
  },
  reducers: {
    saveLgCd: (state, action) => {
      state.lgCd = action.payload.lgCd;
    },
    saveOldIds: (state, action) => {
      state.receptionId = action.payload.receptionId;
      state.citizenId = action.payload.citizenId;
    },
    saveTimearea: (state, action) => {
      state.timearea = action.payload.timearea;
      state.rsvDate = action.payload.rsvDate;
      state.rsvDateWithTime = action.payload.rsvDateWithTime;
      state.rsvDayOfWeek = action.payload.rsvDayOfWeek;
      state.rsvFlameId = action.payload.rsvFlameId || '';
    },
    saveBusiness: (state, action) => {
      state.business = action.payload.business;
      state.recItem = action.payload.recItem;
      state.rsvSetId = action.payload.rsvSetId;
      state.formSetId = action.payload.formSetId ?? '';
    },
    saveUserInfo: (state, action) => {
      state.userName = action.payload.userName;
      state.address = action.payload.address;
      state.birthday = action.payload.birthday;
      state.telNum = action.payload.telNum;
      state.mailAddress = action.payload.mailAddress;
      state.baseName=action.payload.baseName;
    },
    savePlace: (state, action) => {
      state.place.id = action.payload.id;
      state.place.name = action.payload.name;
      state.place.address = action.payload.address;
      state.place.subAddress = action.payload.subAddress;
      state.place.tel = action.payload.tel;
      state.useHome = action.payload.useHome;
      state.rsvFlag = action.payload.rsvFlag;
      if (action.payload.numOfAttendees !== undefined) {
        state.numOfAttendees = action.payload.numOfAttendees;
      }
    },
    saveUrl: (state, action) => {
      state.url = action.payload.url;
    },
    saveSendType: (state, action) => {
      state.sendType = action.payload.sendType;
    },
    saveBusinessChangeMode: (state, action) => {
      state.businessChangeMode = action.payload.businessChangeMode;
    },
    saveBusinessChanged: (state, action) => {
      state.businessChanged = action.payload.businessChanged;
    },
    saveDateChanged: (state, action) => {
      state.dateChanged = action.payload.dateChanged;
    },
    saveNumOfAttendees: (state, action) => {
      state.numOfAttendees = action.payload.numOfAttendees;
    },
    saveOriginalRecItem: (state, action) => {
      state.originalRecItem = action.payload.originalRecItem;
    },
    saveFormAnswers: (state, action) => {
      state.answerList = action.payload.answerList;
      state.numOfAttendees = action.payload.numOfAttendees;
      state.fromChangeForm = action.payload.fromChangeForm;
      state.note = action.payload.note;
    },
    saveNote:(state,action)=>{
      state.note=action.payload.note;
    },
    // 日付選択画面に入った時に前回の選択を消すためのアクション
    clearDate: (state) => {
      state.rsvDate = '';
      state.rsvDayOfWeek = '';
      state.rsvDateWithTime = '';
      state.timearea = '';
      state.rsvFlameId = '';
    },
    // 時間選択画面に入った時に前回の選択を消すためのアクション
    clearTime: (state) => {
      state.rsvDateWithTime = '';
      state.timearea = '';
      state.rsvFlameId = '';
    },
    // 場所選択画面に入った時に前回の選択を消すためのアクション
    // ChangeSelectionSummary は useHome と place.id を見て場所を表示するので、
    // 両方をリセットすることで「場所」欄が非表示になる
    clearPlace: (state) => {
      state.place = { id: '', name: '', address: '', subAddress: '', tel: '' };
      state.useHome = false;
      state.rsvFlag = 0;
    },
    clear: (state) => {
      // state.lgCd = '';
      state.timearea = '';
      state.business = {};
      state.recItem = [];
      state.rsvDate = '';
      state.rsvDateWithTime = '';
      state.rsvDayOfWeek = '';
      state.rsvFlameId = '';
      state.userName = '';
      state.address = '';
      state.birthday = '';
      state.telNum = '';
      state.mailAddress = '';
      state.receptionId = '';
      state.citizenId = '';
      state.url = '';
      state.rsvSetId = '';
      state.sendType = 1;
      state.place = { id: '', name: '', address: '', subAddress: '', tel: '' };
      state.useHome = true;
      state.rsvFlag = 0;
      state.businessChangeMode = 0;
      state.businessChanged = false;
      state.dateChanged = false;
      state.numOfAttendees = 0;
      state.originalRecItem = [];
      state.answerList = [];
      state.fromChangeForm = false;
    },
    setSummaryPanelOpen: (state, action) => {
      state.summaryPanelOpen = action.payload;
    },
    setSummaryExpanded: (state, action) => {
      state.summaryExpanded = action.payload;
    },
  },
});

export const {
  saveLgCd,
  saveTimearea,
  saveBusiness,
  saveUserInfo,
  savePlace,
  clearPlace,
  clearDate,
  clearTime,
  saveOldIds,
  saveUrl,
  saveSendType,
  saveBusinessChangeMode,
  saveBusinessChanged,
  saveDateChanged,
  saveNumOfAttendees,
  saveOriginalRecItem,
  saveFormAnswers,
  saveNote,
  clear,
  setSummaryPanelOpen,
  setSummaryExpanded,
} = reserveChangeSlice.actions;
export const reserveChangeReducer = reserveChangeSlice.reducer;
